/* eslint-disable react/jsx-props-no-spreading */
import React, { ElementType, HTMLAttributes } from 'react';

interface BrandedLeadingProps extends HTMLAttributes<HTMLOrSVGElement> {
  children: string;
  as: ElementType;
  addBrandedFullStop?: boolean;
  classes?: string;
  hrefLink?: string;
}

export default function BrandedLeading({
  as: Tag = 'h1',
  addBrandedFullStop = true,
  children,
  classes,
  hrefLink,
  ...otherProps
}: BrandedLeadingProps) {
  return (
    <Tag
      className={classes}
      {...otherProps}
      dangerouslySetInnerHTML={{
        __html: `${children}${addBrandedFullStop ? `<span class="text-site-primary-600">.</span>` : ''}`,
      }}
      href={hrefLink}
    />
  );
}
